export default {
    portraitOf: 'Portrait of {{employeeName}}',
    completedOn: 'Completed on {{date}}',
    employee: 'Employee',
    evaluation: 'Evaluation',
    reviewers: 'Reviewers',
    errors: {
        loadFailed: 'Failed to load results',
        loadFailedDescription: 'Unable to retrieve the post-review results. Please try again.',
    },
    performance: {
        label: 'Performance',
        placeholder: 'Select score',
        exceptional: 'Exceptional',
        exceeds: 'Exceeds Expectations',
        meets: 'Meets Expectations',
        developing: 'Developing',
        improvement: 'Needs Improvement',
        saveFailed: 'Failed to save the performance score. Please try again.',
        notObserved: 'Not Observed',
    },
    valuesAlignment: 'Adherence to Company Values',
    tabs: {
        summary: 'Summary',
        competencies: 'Competencies',
        comparison: 'Comparison',
        notesResources: 'Notes & Resources',
        summaryPlaceholder: 'Summary content will be displayed here.',
        competenciesPlaceholder: 'Competencies content will be displayed here.',
    },
    summary: {
        assessmentNotReady:
            'The assessment is not ready to generate a summary. Complete and submit the assessment first.',
        aiAnalysis: 'Intelligent Evaluation Summary',
        aiDescription: 'AI-driven in-depth analysis based on evaluation data',
        strengths: 'Strengths',
        developmentAreas: 'Development Areas',
        regenerate: 'Regenerate',
        regenerating: 'Regenerating...',
        additionalInsights: 'Additional Insights',
        overallPerformance:
            'Overall, the employee demonstrates strong performance with clear areas for continued growth.',
        recommendedActions:
            'Recommended actions include focused development planning and regular feedback sessions.',
        noData: 'AI summary will be generated after the assessment is completed.',
        noStrengthsTitle: 'No strengths identified this cycle',
        noStrengthsDescription:
            'None of the competencies reached the strength threshold. The development areas below show where to focus first.',
        noDevelopmentAreasTitle: 'No development areas identified this cycle',
        noDevelopmentAreasDescription:
            'Every competency met or exceeded expectations. A strong cycle overall.',
        loadErrorTitle: 'The AI summary could not be loaded.',
        loadErrorDescription: 'Something went wrong while generating this summary.',
        /** A summary keeps the one language it was generated in: said to a reader of the other language. */
        writtenInLanguage: {
            en: 'Summary written in English',
            fr: 'Summary written in French',
        },
    },
    competencies: {
        title: 'Competency Results',
        description:
            'You are viewing the most up-to-date competency assessment for {{employeeName}}. Competency scores include only those from a {{managerLabel}}. 360 feedback and self-assessments are not counted in competency scores.',
        editProficiency: 'Edit Proficiency',
        editProficiencyDescription: 'Modify the proficiency level',
        noCompetencies: 'No competencies have been evaluated yet.',
        lastUpdated: 'Last updated {{date}}',
        updatedBy: 'Updated by {{name}}',
        assessment: {
            description:
                'You are viewing the most up-to-date competency assessment for {{employeeName}}. Competency scores include only those from a {{managerLabel}}. 360 feedback and self-assessments are not counted in competency scores.',
        },
        proficiencyLevel: 'Proficiency Level',
        comment: 'Comment',
        commentDescription: '(optional)',
        commentPlaceholder: 'Add a comment about this assessment...',
        manual: 'Manual',
        noData: 'No data',
        proficiencyLevels: 'Proficiency Levels',
        assessmentHistory: 'Assessment History',
        noHistory: 'No assessment history available.',
        viewHistory: 'View history',
        edit: 'Edit',
        proficiency: {
            mastered: 'Mastered',
            almostAchieved: 'Almost Achieved',
            evolution: 'In Progress',
            notMet: 'Not Met',
        },
        levels: {
            expert: 'Expert',
            advanced: 'Advanced',
            satisfactory: 'Satisfactory',
            evolution: 'Evolution',
            junior: 'Junior',
        },
    },
    proficiency: {
        title: 'Proficiency Distribution',
        description: '{{total}} competencies evaluated',
        mastered: 'Mastered',
        satisfactory: 'Satisfactory',
        developing: 'Developing',
        needsImprovement: 'Needs Improvement',
        notMet: 'Not Met',
        growth: 'Growth',
        almostAchieved: 'Almost Achieved',
        notDetermined: 'N.D.',
    },
    competencyEdit: {
        title: 'Edit Competency Proficiency',
        selectLevel: 'Select Proficiency Level',
        commentLabel: 'Comment (optional)',
        commentPlaceholder: 'Explain why you are changing this rating…',
        save: 'Save',
        cancel: 'Cancel',
        saveFailed: 'Failed to save the proficiency level. Please try again.',
    },
    history: {
        title: 'Rating History',
        viewHistory: 'View history',
        empty: 'No rating history yet.',
        manual: 'Manually modified',
        survey: 'Survey-based',
        close: 'Close',
    },
    notes: {
        title: 'Notes for this evaluation',
        empty: 'No details were added while completing the questionnaire.',
        loading: 'Loading the notes of this evaluation…',
        loadError: 'The notes of this evaluation could not be loaded.',
        preparationResources: 'Preparation Resources',
        preparationDescription:
            'Here are elements about your employee to help you prepare your meeting.',
        selfAssessment: 'Self-Assessment',
        selfAssessmentDescription: "Review the employee's self-assessment of their competencies",
        feedback360: '360° Feedback',
        feedback360Description: 'Review feedback from colleagues and supervisors',
        objectives: 'Their Objectives',
        objectivesDescription: 'Review current professional objectives',
        notAvailable: 'Not available yet',
    },
    valuesAlignmentNotAvailable: 'N.A.',
};
